import * as Common from '@/tenant/common';

export class SlipJournalItemReportQuery extends Common.ReportQuery {
    constructor(){
        super("SlipJournalItemReportQuery", null);
    }
    public salesPurchaseFlag: number;
    public segment: Common.Segment = null;
    public account: Common.Account = null;
    public startDate: Date = null;
    public endDate: Date = null;
    public onExcelExport:boolean = false;           
}

export class SlipJournalItemReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='SlipJournalItemReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}
